import { BrowserModule } from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import { AppComponent } from './app.component';
import {LoaderComponent} from './components/loader/loader.component';
import {LoaderService} from './components/loader/loader.service';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MDBBootstrapModulesPro, ToastModule} from 'ng-uikit-pro-standard';
import {LoginComponent} from './modules/login/login.component';
import {AppRoutingModule} from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {SharedModule} from './modules/shared/shared.module';
import {ApplicationConfig} from './config/application.config';
import {ForgotPasswordComponent} from './modules/forgot-password/forgot-password.component';
import {AuthInterceptor} from './http/auth.interceptor';
import {ApiRoutes} from './config/api-routes';
import {LoggedInGuard} from './guards/logged-in.guard';
import {SetPasswordComponent} from './modules/set-password/set-password.component';
import { CookieService } from 'ngx-cookie-service';
import {DashboardComponent} from './modules/dashboard/dashboard.component';
import {NotLoggedInGuard} from './guards/not-logged-in.guard';
import {SignoutComponent} from './modules/signout/signout.component';
import {GlobalErrorHandler} from './config/global-error-handler';
import {environment} from '../environments/environment';
import {LoginService} from './modules/login/login.service';
import { AccountConfirmComponent } from './modules/account/account-confirm/account-confirm.component';
import { ApplicationModalComponent } from './modules/dashboard/application-modal/application-modal.component';
import { BlurredImageComponent } from './components/blurred-image/blurred-image.component';
import {LicenseAgreementService} from "./modules/license/license-agreement.service";
import {AgreeLicenseModalComponent} from "./modules/license/agree-license-modal/agree-license-modal";
import {MatDialogModule} from "@angular/material/dialog";
import {LicenseService} from "./modules/license/license.service";
import { AccountDeletedComponent } from './modules/account/deletion/account-deleted/account-deleted.component';
import { TwoFactorAuthComponent } from './modules/two-factor-auth/two-factor-auth.component';
import {ChappsCommonAngularLibraryModule} from "@npm.chapps.com/chapps.common.angular.library";
import {NgOtpInputModule} from "ng-otp-input";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.apiUrl + 'api/translations/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    LoginComponent,
    ForgotPasswordComponent,
    SetPasswordComponent,
    DashboardComponent,
    ApplicationModalComponent,
    SignoutComponent,
    AccountConfirmComponent,
    BlurredImageComponent,
    AgreeLicenseModalComponent,
    AccountDeletedComponent,
    TwoFactorAuthComponent,
  ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({loader: {provide: TranslateLoader, useFactory: (createTranslateLoader), deps: [HttpClient]}}),
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        HttpClientModule,
        ToastModule.forRoot(),
        MDBBootstrapModulesPro.forRoot(),
        SharedModule,
        MatDialogModule,
        NgOtpInputModule,
    ],
  providers: [
    LoaderService,
    ApplicationConfig,
    ApiRoutes,
    LoggedInGuard,
    NotLoggedInGuard,
    LoginService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler},
    CookieService,
    LicenseService,
    LicenseAgreementService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

